import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import * as routerHelpers from "app/router/RouterHelpers";

/**
 * Custom hook to track last location (replacement for react-router-last-location)
 * Compatible with React Router v6
 */
export function useLastLocation() {
  const location = useLocation();

  useEffect(() => {
    routerHelpers.saveLastLocation(location);
  }, [location]);

  return routerHelpers.getLastLocation();
}
